import { IPlan } from "@stores/plans/types";
import { useAccount } from "@stores/session/hooks";
import ConfirmationModal from "@components/account/plans/ConfirmationModal";
import StripeProvider from "@components/thirdParty/stripe/StripeProvider";
import { usePurchaseContext } from "../../hooks";

/** converts a trial early so metered usage can keep billing */
export function TrialConversionModal({
  opened,
  onClose,
}: {
  opened: boolean;
  onClose: () => void;
}) {
  const account = useAccount();
  const { purchase, isYearly } = usePurchaseContext();

  // StripeProvider injects js.stripe.com on mount, so keep it behind `opened`
  if (!account || !opened) {
    return null;
  }

  const plan = {
    alias: purchase.product.plan.alias,
    name: purchase.product.plan.billing_details_name,
  } as IPlan;

  return (
    <StripeProvider>
      <ConfirmationModal
        account={account}
        isYearly={isYearly}
        plan={plan}
        purchase={purchase}
        redirectTo={window?.location?.pathname}
        opened={opened}
        onClose={onClose}
      />
    </StripeProvider>
  );
}
